import { Component, OnInit } from '@angular/core';
import {
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { SsoService } from './services/sso/sso.service';
import { environment } from '../environments/environment';
import { CommonModule, NgClass } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { MainModule } from './components/main/main.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UsersModule } from './components/users/users-module';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApiInterceptor } from './services/api/api.interceptor';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    FormsModule,
    NzModalModule,
    UsersModule,
    MainModule,
  ],
})
export class AppComponent implements OnInit {
  private timerInactividad = null;
  public menuData: any = null;

  constructor(
    private ssoService: SsoService,
    private router: Router,
  ) {}

  async ngOnInit() {
    // Según el origen de la llamada obtengo la URL de la api correspondiente, si no se
    // encuentra el origen prevalecen los datos configurados en las variables de entorno
    const urlOrigin = new URLSearchParams(window.location.search).get('origin');
    if (urlOrigin) {
      // if (urlOrigin.startsWith('my.movisat.com')) {
      //   environment.apiSSO = 'https://api.sso.movisat.com';
      //   environment.webSSO = 'https://my.movisat.com';
      // } else {
      //   if (urlOrigin.startsWith('preproduccion.my.movisat.com')) {
      //     environment.apiSSO = 'https://api.sso.preproduccion.movisat.com';
      //     environment.webSSO = 'https://preproduccion.my.movisat.com';
      //   } else {
      //     environment.apiSSO = 'https://api.sso.dev.movisat.com';
      //     environment.webSSO = 'https://dev.my.movisat.com';
      //   }
      // }

      // environment.webSSO = 'http://localhost:4200';
      // environment.apiSSO = 'https://localhost:44343';

      // Antes de nada pido el token del SSO para que se almacene en el localstorage
      await this.ssoService.getToken();
      sessionStorage.setItem('ssoCrud-api', environment.apiSSO);
      sessionStorage.setItem('ssoCrud-web', environment.webSSO);

      // Control de eventos de enrutamiento
      this.router.events.subscribe(async (event) => {
        // Cada vez que se carga una página
        if (event instanceof NavigationStart) {
          if (!event.url.startsWith('/?ticketId=')) {
            // Se cormprueba que hay ticket SSO válido
            const ticket = this.ssoService.getTicket();
            if (
              ticket === null ||
              !(await this.ssoService.isUsuarioValidado(ticket.Usuario.Id))
            ) {
              this.logout();
            }
          }
          // Si se accede a una página que no existe
          if (event instanceof NavigationError) {
            this.logout();
          }
        }
      });
      // Si no tengo el ticket del SSO intento recuperarlo
      const ticketId = new URLSearchParams(window.location.search).get(
        'ticketId',
      );
      if (ticketId || !(await this.ssoService.getTicket())) {
        // Recupero el ticket del SSO con el id recibido
        if (await this.ssoService.initSession(ticketId)) {
          this.login();
        } else {
          this.logout();
        }
      } else {
        if (window.location.pathname === '/') {
          this.login();
        }
      }
    } else {
      const ticket = this.ssoService.getTicket();
      if (!ticket) {
        this.logout();
      }
      // if (ticket.UrlApi.startsWith('https://api.np.movisat.com')) {
      //   environment.apiSSO = 'https://api.sso.movisat.com';
      //   environment.webSSO = 'https://my.movisat.com';
      // } else {
      //   if (
      //     ticket.UrlApi.startsWith(
      //       'https://api.np.preproduccion.my.movisat.com',
      //     )
      //   ) {
      //     environment.apiSSO = 'https://api.sso.preproduccion.movisat.com';
      //     environment.webSSO = 'https://preproduccion.my.movisat.com';
      //   } else {
      //     environment.apiSSO = 'https://api.sso.dev.movisat.com';
      //     environment.webSSO = 'https://dev.my.movisat.com';
      //   }
      // this.login();
      // }

      this.registrarInactividad();
    }
  }

  // Redirijo a la página de login del SSO
  private logout(): void {
    this.ssoService.endAppSession();
  }

  private registrarInactividad(): void {
    let t;

    // Resetea el temporizador en cada acción del usuario
    window.onload = reiniciarTiempo;
    document.onmousemove = reiniciarTiempo;
    document.onkeypress = reiniciarTiempo;
    document.ontouchstart = reiniciarTiempo;
    document.onclick = reiniciarTiempo;
    document.onscroll = reiniciarTiempo;

    // Función que se ejecuta después de 15 minutos de inactividad
    function tiempoExcedido() {
      alert('Se ha cerrado la sesión después de 15 minutos sin actividad.');
      window.location.replace(environment.webSSO); // Redirige al login
    }

    // Reinicia el temporizador
    function reiniciarTiempo() {
      clearTimeout(t);
      t = setTimeout(tiempoExcedido, 900000); // 900000 ms = 15 minutos
    }
  }

  // Cargo el menú y redirijo a la página principal
  private async login() {
    this.router.navigateByUrl('/main');
  }
}
